'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getToken = getToken;
exports.loadSaga = loadSaga;

var _effects = require('redux-saga/effects');

var _InviteAFriend = require('containers/InviteAFriend/InviteAFriend.saga');

var _selectors = require('redux/saga/selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getToken),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(loadSaga);

function getToken() {
  var currentPath;
  return _regenerator2.default.wrap(function getToken$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_selectors.pathSelector);

        case 2:
          currentPath = _context.sent;

          if (!/^(\/invite\/)/.test(currentPath)) {
            _context.next = 5;
            break;
          }

          return _context.abrupt('return', /[^/]*$/.exec(currentPath)[0]);

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function loadSaga(client) {
  var token;
  return _regenerator2.default.wrap(function loadSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(getToken);

        case 3:
          token = _context2.sent;
          _context2.next = 6;
          return (0, _effects.call)(_InviteAFriend.doLoadInviteAFriend, client, { token: token });

        case 6:
          _context2.next = 12;
          break;

        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 12;
          return (0, _effects.put)((0, _InviteAFriend.loadInviteAFriendError)(_context2.t0));

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 8]]);
}